import React from "react";
import { useHistory } from "react-router-dom";
import appLogo from "assets/logo/logo-only.png";
import rapidImg from "assets/images/transaction-stack.png";
import { StackAnalysisProvider } from "context/stack_analysis";
import StackAnalysisToolbar from "../components/StackAnalysisToolbar";
import StackAnalysisPage from "../components/StackAnalysisPage";
import "./index.scss";

const StackAnalysisContainer = () => {
  const history = useHistory();

  return (
    <StackAnalysisProvider>
      <sidebar className="side-bar">
        <img
          data-testid="app-logo"
          className="app-logo"
          src={appLogo}
          alt="alt"
          onClick={() => history.push("/")}
          aria-hidden
        />
        <div className="backdrop-image">
          <img
            data-testid="transaction-img"
            className="rapid-image"
            src={rapidImg}
            alt="alt"
          />
        </div>
      </sidebar>
      <div className="stack-analysis">
        <StackAnalysisToolbar />
        <StackAnalysisPage />
      </div>
    </StackAnalysisProvider>
  );
};

export default StackAnalysisContainer;
